export enum PaymentResultViewTypes {
  Success,
  PartiallySuccess,
  Failed,
}
